import ExternalTransfersPage from "components/pages/ExternalTransfersPage"; 

export default function CaptureExternalTransfersTransfer(props) {
    return <ExternalTransfersPage />
}